export enum HeaderVariations {
  centered = 'headerCentered',
  centeredSmall = 'headerCenteredSmall',
  left = 'headerLeft',
  leftDark = 'headerLeftDark',
  inner = 'headerInner'
}
